import { IMenu } from 'components/general/types';
import { SUB_ITEMS, TITLE } from 'config';

export const GENERIC_COMPONENTS = 'genericComponents';

const aTGenericComponentsMenu: IMenu['items'] = {
  [GENERIC_COMPONENTS]: {
    [TITLE]: 'Generic Components',
    [SUB_ITEMS]: {}, // this is where subsystems will be dynamically added\
  },
};
export const wGroupIndicesATGenericComponents = {
  GENERIC_COMPONENTS: `${GENERIC_COMPONENTS}*`,
};

export default aTGenericComponentsMenu;
